export default () => ({
    status: 'authenticating', // authenticated not-authenticated authenticating
    idToken: null,
    lstMeets: [],
    lstClubes: [],
    selectClubes: [],
    lstUsuarios: []
})
